








































import { Component, Vue, Mixins } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";

import { DispatchRequest, MobileFeatures, DispatchType } from "@/store/mobile/types";
import DispatchQueueItem from "@/components/mobile/dispatch/DispatchQueueItem.vue";

import DispatchMixin from "@/mixins/DispatchMixin";

const Mobile = namespace("mobile");

@Component({
	components: {
		"dispatch-queue-item": DispatchQueueItem
	}
})
export default class DispatchQueueList extends Mixins(DispatchMixin)  {
	// Feature flag
	@Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	// Dispatch Request store modifiers
	@Mobile.Getter("getClaimedDispatchRequests")
	claimedDispatchRequests: DispatchRequest[];
	@Mobile.Getter("getUnclaimedDispatchRequests")
	unclaimedDispatchRequests: DispatchRequest[];
	@Mobile.Getter("getDispatchRequests") dispatchRequests: DispatchRequest[];

	// Used due to inaccessable enum from template.
	private dispatchType: any = DispatchType;

	public get isMobileDispatchEnabled() {
		return this.getFeature(["Mobile", "Dispatch"]);
	}	

	private get groupDispatchItemsClaimed() {
		return this.displayDispatchRequest(this.claimedDispatchRequests, false);
	}

	private get groupDispatchItemsUnclaimed() {
		return this.displayDispatchRequest(this.unclaimedDispatchRequests, false);
	}	
}
